// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__10pgU","bigColWidth":"Table_bigColWidth__HmEgm","biggerColWidth":"Table_biggerColWidth__29mvh","row":"Table_row__2pkoV","col":"Table_col__2wDTP"};